import Vue from 'vue'
import utils from '~/assets/js/utils'

export default ({ app }) => {
	app.validateDiscount = utils.validateDiscount
	app.validateConditions = utils.validateConditions

	Vue.mixin({
		methods: {
			...utils
		}
	})
}
